import { GridApi } from "ag-grid-community";
import { mapValues } from "lodash";
import { utcDate } from "~utils/Date.ts";

export function getFilterModel(api: GridApi): string {
	const filterModel = mapValues(api.getFilterModel(), (filter) => {
		if (utcDate(filter.dateFrom).isSame(utcDate(), "day")) {
			return {
				...filter,
				dateFrom: "$today",
			};
		}

		return filter;
	});

	return JSON.stringify(filterModel);
}
